import { motion } from "framer-motion";
import {
  Share2,
  Briefcase,
  Megaphone,
  LayoutTemplate,
  ShoppingCart,
  ArrowUpRight,
} from "lucide-react";

const services = [
  {
    id: "auditoria",
    title: "Auditoría de Redes Sociales y Web",
    desc: "Análisis completo de tu presencia digital para identificar oportunidades de mejora y optimización de resultados.",
    icon: Share2,
    span: "md:col-span-3",
  },
  {
    id: "plan-negocios",
    title: "Plan de Negocios",
    desc: "Desarrollo estratégico de planes de negocio personalizados para impulsar el crecimiento de tu empresa.",
    icon: Briefcase,
    span: "md:col-span-3",
  },
  {
    id: "meta-ads",
    title: "Configuración de Meta Ads",
    desc: "Configuración profesional de campañas publicitarias en Facebook e Instagram para maximizar tu ROI.",
    icon: Megaphone,
    span: "md:col-span-2",
  },
  {
    id: "landing",
    title: "Creación de Landing Page",
    desc: "Diseño y desarrollo de páginas de aterrizaje optimizadas para conversión y generación de leads.",
    icon: LayoutTemplate,
    span: "md:col-span-2",
  },
  {
    id: "ecommerce",
    title: "Creación de E-commerce",
    desc: "Implementación completa de tiendas online profesionales con integración de pagos y gestión de inventario.",
    icon: ShoppingCart,
    span: "md:col-span-2",
  },
];

export default function Services() {
  const goContact = (service) => {
    const el = document.getElementById("contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setTimeout(() => {
      const event = new CustomEvent("preselect-service", { detail: service });
      window.dispatchEvent(event);
    }, 600);
  };

  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="bg-[#F4F7F9] py-24 lg:py-32 border-y border-[#E2E8F0]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.3em] uppercase text-[#475569] mb-5">
              — 02 / Servicios
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#0A192F]">
              Servicios <span className="italic">profesionales</span>.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-base sm:text-lg text-[#475569] leading-relaxed">
              Soluciones integrales de marketing digital y e-commerce diseñadas
              para impulsar tu negocio. Cada servicio se adapta a tu etapa y a
              tus objetivos.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-px bg-[#0A192F]">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.button
                key={s.id}
                onClick={() => goContact(s.title)}
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{
                  duration: 0.6,
                  delay: i * 0.08,
                  ease: [0.2, 0.8, 0.2, 1],
                }}
                className={`group relative ${s.span} text-left bg-white p-8 lg:p-10 hover:bg-[#0A192F] transition-colors duration-500`}
              >
                <div className="flex items-start justify-between mb-10">
                  <div className="w-12 h-12 border border-[#0A192F] group-hover:border-white flex items-center justify-center transition-colors duration-500">
                    <Icon
                      size={20}
                      strokeWidth={1.5}
                      className="text-[#0A192F] group-hover:text-white transition-colors duration-500"
                    />
                  </div>
                  <ArrowUpRight
                    size={20}
                    strokeWidth={1.5}
                    className="text-[#0A192F] group-hover:text-white opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all duration-500"
                  />
                </div>

                <span className="font-mono text-[10px] tracking-[0.3em] text-[#475569] group-hover:text-white/70 uppercase transition-colors duration-500">
                  0{i + 1}
                </span>
                <h3 className="mt-3 font-display text-2xl lg:text-[28px] leading-tight text-[#0A192F] group-hover:text-white transition-colors duration-500">
                  {s.title}
                </h3>
                <p className="mt-4 text-sm sm:text-base text-[#475569] group-hover:text-white/80 leading-relaxed transition-colors duration-500">
                  {s.desc}
                </p>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
